export const ALLOWED_AFTER_LOGIN_PATHS = [
    '/account/settings/profile',
    '/account/settings/account',
    '/account/settings/badges',
    '/account/settings/extensions',
    '/account/subscription',
];
export const BLACKLISTED_COUNTRY_CODES = ['RU'];
